package views

import StoreContext
import components.*
import kotlinx.coroutines.isActive
import mui.material.*
import mui.material.styles.TypographyVariant
import mui.system.responsive
import mui.system.sx
import react.FC
import react.Props
import react.dom.html.ReactHTML.main
import react.router.useNavigate
import react.useContext
import react.useState
import screens.CodeScreen
import screens.EnterScreen
import support.sceneInputOf
import support.useAsyncEffect
import techla.base.techla_log
import web.cssom.*

val Enter = FC<Props> {
    val (store, dispatch) = useContext(StoreContext)
    val (viewModel, setViewModel) = useState(EnterScreen.ViewModel.None as EnterScreen.ViewModel)

    var email by useState("")
    val navigate = useNavigate()

    suspend fun onSubmit() {
        EnterScreen.handleSubmit(sceneInputOf(store, viewModel), email).also { (viewModel, actions) ->
            setViewModel(viewModel)
            dispatch(actions)
        }
    }

    useAsyncEffect(viewModel) { coroutineScope ->
        when (viewModel) {
            is EnterScreen.ViewModel.None -> if (coroutineScope.isActive) {
                EnterScreen.load(sceneInputOf(store, viewModel)).also { (viewModel, actions) ->
                    setViewModel(viewModel)
                    dispatch(actions)

                    if (store.isSignedIn) navigate("/book")
                }
            }

            is EnterScreen.ViewModel.Ready -> {}
            is EnterScreen.ViewModel.Enter -> navigate("/book")

            is EnterScreen.ViewModel.Submitted -> navigate("/code")


            is EnterScreen.ViewModel.Failed -> techla_log("Failed")
        }
    }

    main {
        HNavbar {}
        if (viewModel is EnterScreen.ViewModel.None) {
            Container {
                maxWidth = "sm"
                sx {
                    height = 100.vh
                }
                Stack {
                    spacing = responsive(6)
                    sx {
                        justifyContent = JustifyContent.center
                        alignItems = AlignItems.center
                        height = 100.pct
                    }
                    CircularProgress {
                        size = 80.px
                        thickness = 4.5
                    }
                }
            }
        }
        if (viewModel is EnterScreen.ViewModel.Failed) {
            Failure { design = viewModel.failure; onClick = { navigate("/") } }
        } else {
            Container {
                maxWidth = "sm"
                sx {
                    height = 50.vh
                }

                Stack {
                    spacing = responsive(6)
                    sx {
                        justifyContent = JustifyContent.flexEnd
                        height = 100.pct
                    }

                    Typography {
                        align = TypographyAlign.center
                        variant = TypographyVariant.h1

                        +"ENTER THE ZONE"
                    }

                    Typography {
                        align = TypographyAlign.center
                        variant = TypographyVariant.body1

                        +"Dear Hetcher here we have som special nifty features for you. Any questions just contact team HETCH at "
                        Link {
                            href = "mailto:hello@hetch.se"
                            +"hello@hetch.se"
                        }
                    }

                    HForm {
                        onSubmit = ::onSubmit

                        Stack {
                            spacing = responsive(2)

                            HInput {
                                design = viewModel.emailInput
                                onChange = { value -> email = value }
                            }

                            HButton { design = viewModel.submit }
                        }
                    }
                    Typography {
                        align = TypographyAlign.center
                        variant = TypographyVariant.body1

                        +store.version
                    }
                }
            }
        }
    }
}